import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import {fontFamily} from '../../helpers/fontFamily';
import {isMultiPutWall} from '../../helpers/productFirstWorkflow';
import {openAction} from '../../actions/productFirstActions';
import {
  selectToteIdentifier,
  selectProductFirstToteSet,
  selectScanPackWorkflow
} from '../../selectors/productFirstSelectors';

const ToteSetSwitch = () => {
  const dispatch = useDispatch();
  const workflow = useSelector(selectScanPackWorkflow);
  const toteIdentifier = useSelector(selectToteIdentifier);
  const toteSet = useSelector(selectProductFirstToteSet);

  if (!isMultiPutWall(workflow)) return null;

  return (
    <View style={styles.row}>
      <TouchableOpacity
        testID="toteSetSwitch"
        style={styles.button}
        onPress={() => dispatch(openAction('SwitchToteSet'))}>
        <Text style={styles.text}>
          {i18n.t('productFirst.toteSetButton', {
            toteIdentifier,
            name: toteSet?.name || ''
          })}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 10,
    paddingVertical: 8
  },
  button: {
    backgroundColor: '#2c3e50',
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 5
  },
  text: {
    color: '#fff',
    fontSize: 14,
    fontFamily: fontFamily.font600
  }
});

export default ToteSetSwitch;
